import { type ShiftAuction, ShiftAuctionStatus } from "@clipboard-health/contract-worker-app-bff";

import { API_TYPES, type Offer, type OpenShiftWorkplace, type RateNegotiation } from "./types";
import { type GetOpenShiftsResponse } from "./useGetOpenShifts";

export function getIncludedOpenShiftsData(data?: GetOpenShiftsResponse) {
  const workplacesMap = new Map<string, OpenShiftWorkplace>(
    ((data?.included ?? []) as OpenShiftWorkplace[])
      .filter((entity) => entity.type === API_TYPES.workplace)
      .map((workplace) => [workplace.id, workplace])
  );

  const rateNegotiationsMap = new Map<string, RateNegotiation>(
    ((data?.included ?? []) as RateNegotiation[])
      .filter((entity) => entity.type === API_TYPES.rateNegotiation)
      .map((rateNegotiation) => [rateNegotiation.id, rateNegotiation])
  );

  const offersMap = new Map<string, Offer>(
    ((data?.included ?? []) as Offer[])
      .filter((entity) => entity.type === API_TYPES.offer)
      .map((offer) => [offer.id, offer])
  );

  const shiftAuctionsMap = new Map<string, ShiftAuction>(
    ((data?.included ?? []) as ShiftAuction[])
      .filter(
        (entity) =>
          entity.type === API_TYPES.shiftAuction &&
          entity.attributes.status === ShiftAuctionStatus.OPEN
      )
      .map((shiftAuction) => [shiftAuction.id, shiftAuction])
  );

  return {
    workplacesMap,
    rateNegotiationsMap,
    offersMap,
    shiftAuctionsMap,
  };
}
